<template>
	<el-container style="background-color: #EEEEEE;height: 100%;">
		<el-header class="exercise-header">
			<span class="back-btn" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
		</el-header>
		<el-main style="padding-bottom:100px;">
			<div class="exercise-body">
				<div class="exercise-condition">
					<div class="exercise-progress">
						<div class="exercise-paper-info">
							<i class="el-icon-question paperinfo" @mouseover="paperinfo=true" @mouseout="paperinfo=false"></i>
						</div>
						<div class="exercise-progress-status">
							<el-progress :show-text="false" :stroke-width="10" :percentage="percentage"></el-progress>
						</div>
						<div class="exercise-progress-plan">
							{{currentExercise+1}}/{{totalExercise}}
						</div>
					</div>
					<div class="exercise-time">
						<div class="exercise-time-post">
							<el-button type="danger" size="small" @click="postPaper">提交</el-button>
						</div>
					</div>
				</div>
				<div class="exercise-content">
					<div class="exercise-content-title">
						<span>【{{questionType | returnType}}】</span>
						<span>({{singleScore}}分)</span>
					</div>
					<div class="exercise-content-body" v-for="(item,index) in currentList" :key="index">
							<template v-if="questionType==1&&index==currentIndex">
								<DoSc ref="mychild" :itemContent="item" :index="index" :currentIndex="currentExercise" :status="paper_status" :recordId="recordId"></DoSc>
							</template>
							<template v-else-if="questionType==2&&index==currentIndex">
								<DoMc ref="mychild" :itemContent="item" :index="index" :currentIndex="currentExercise" :status="paper_status" :recordId="recordId"></DoMc>
							</template>
							<template v-else-if="questionType===3&&index==currentIndex">
								<DoJuge ref="mychild" :itemContent="item" :index="index" :currentIndex="currentExercise" :status="paper_status" :recordId="recordId"></DoJuge>
							</template>
							<template v-else-if="questionType===4&&index==currentIndex">
								<DoFill ref="mychild" :itemContent="item" :index="index" :currentIndex="currentExercise" :status="paper_status" :recordId="recordId"></DoFill>
							</template>
							<template v-else-if="questionType===7&&index==currentIndex">
								<DoExplain ref="mychild" :itemContent="item" :index="index" :currentIndex="currentExercise" :status="paper_status" :recordId="recordId"></DoExplain>
							</template>
							<template v-else-if="questionType===8&&index==currentIndex">
								<DoShort ref="mychild" :itemContent="item" :index="index" :currentIndex="currentExercise" :status="paper_status" :recordId="recordId"></DoShort>
							</template>
							<template v-else-if="questionType===9&&index==currentIndex">
								<DoTrain ref="mychild" :itemContent="item" :index="index" :currentIndex="currentExercise" :status="paper_status" :recordId="recordId"></DoTrain>
							</template>
							<template v-else-if="questionType===10&&index==currentIndex">
								<DoMs ref="mychild" :itemContent="item" :index="index" :currentIndex="currentExercise" :status="paper_status" :recordId="recordId"></DoMs>
							</template>
					</div>
					<div class="next-question">
						<el-button type="primary" @click="nextQuestion" v-if="currentExercise<totalExercise-1">下一题</el-button>
					</div>
				</div>
				<i class="divider-line"></i>
				<div class="answer-list">
					<h2>答题卡</h2>
					<ul class="answer-list-box">
						<li class="answer-list-options" v-for="(item,index) in answerBtn" :key="index">
							<span @click="checkQuestion(item.index,item.type,index)" :class="jugeStatus(index,item.status)">
								{{index+1}}
							</span>
						</li>
						<div style="clear: both;"></div>
					</ul>
				</div>
			</div>
		</el-main>
		<div v-if="paperinfo" class="pop-info">
			<div class="paper-info-left">
				<h2 class="paper-title">{{paperTitle?paperTitle:'试卷名称'}}</h2>
				<div style="height: 100px;display: flex;">
					<div class="paper-icon">
						<img :src="icon?icon:require('../../assets/imgs/mark.png')"/>
					</div>
					<div class="info-list">
						<div class="info-list-item">
							<span class="title-label">难度：</span><span class="title-content">{{difficulty | retrunDifficulty}}</span>
						</div>
						<div class="info-list-item">
							<span class="title-label">试卷题型：</span>
							<span class="title-content">
								<template v-for="(q,idx) in testTypes">{{q.name}}{{q.count}}题{{idx===testTypes.length-1?'。':'、'}}</template>
							</span>
						</div>
					</div>
				</div>
				<div class="test-introduce" style="height: 200px;word-break:break-all;">
					<div v-html="test_introduce"></div>
				</div>
			</div>
		</div>
	</el-container>
</template>

<script>
	import {userOpenTrainAnswerData,userSubmitPaperData,returnQuestionType,returnType,retrunDifficulty,answeIfNull} from '@/api/show';
	import DoSc from '@/components/result/DoSingleChoice';
	import DoMc from '@/components/result/DoMultipleChoice';
	import DoJuge from '@/components/result/DoJugeMent';
	import DoFill from '@/components/result/DoFill';
	import DoShort from '@/components/result/DoShort';
	import DoExplain from '@/components/result/DoExplain';
	import DoTrain from '@/components/result/DoTrain';
	import DoMs from '@/components/result/DoMultipleSort';
	import CountDown from '@/components/show/CountDown';
	import EndTest from '@/components/result/EndTest';
	export default{
		components:{
			CountDown,
			DoSc,
			DoMc,
			DoJuge,
			DoFill,
			DoShort,
			DoExplain,
			DoTrain,
			DoMs,
			EndTest,
		},
		mounted(){
			window.onbeforeunload = e => {
				if (this.$route.fullPath === "/train/exercise") {
					e = e || window.event;
					if (e) {
					e.returnValue = "关闭提示";
					}
					return "关闭提示";
				}
			};
			if(Object.keys(this.$route.params).length > 0){
				this.paperId = this.$route.params.paperId
				this.competitionId = this.$route.params.competitionId
				this.replay_type = this.$route.params.replay_type
				this.classroom_id = this.$route.params.classroom_id
				let info = {
					paperId:this.paperId,
					competitionId:this.competitionId,
					replay_type:this.replay_type,
					classroom_id:this.classroom_id,
				}
				sessionStorage.setItem('paperInfo',JSON.stringify(info))
			}else{
				let info = JSON.parse(sessionStorage.getItem('paperInfo'))
				if(!info)return
				this.paperId = info.paperId
				this.competitionId = info.competitionId
				this.replay_type = info.replay_type
				this.classroom_id = info.classroom_id
			}
			this.$root.$on('returnanswer', (subjectObj)=>{
				if(Object.keys(subjectObj).length > 0) {
					if(!this.answerList[subjectObj.type]){
						this.answerList[subjectObj.type] = []
					}
					this.answerList[subjectObj.type][subjectObj.index] = subjectObj.answer
					this.jugeItemStatus(subjectObj.type,subjectObj.index,subjectObj.currentIndex)
				}
			})
			this.initData()
		},
		watch:{
			currentExercise: function(){
				this.changeAnswer()
			},
			questionType: function(){
				let ind = this.questionList.findIndex((val)=>{
					return val.paper_type === this.questionType
				})
				if(ind!==-1){
					this.currentList = this.questionList[ind].paper_info
				}
			},
		},
		data(){
			return {
				currentExercise:0,//当前题下标
				totalExercise:0,//总题量
				questionType:'',//题目类型
				paperId:'',//试卷id
				competitionId:'',//教师发布到班级的id
				questionList:[],//试卷所有内容
				answerList:{},//答题卡
				currentAnswer:'',//当前题答案
				endTestVisible:false,
				answerBtn:[],//题目按钮
				currentList:[],//当前类型所有题目
				currentIndex:0,//当前题目在该类型题目中的下标值,默认0
				singleScore:'',//单题分数
				paper_status:0,//试卷状态，训练没有结束时间，任何时候都可以做题
				paperTitle:'',//试卷名称
				icon:'',//试卷图标
				difficulty:'',//考试难度
				test_introduce:'',//试卷介绍
				testTypes:[],//考卷包含题型
				paperinfo:false,//悬浮显示试卷信息
				recordId:'',//做题记录id
				replay_type:1,//是正常训练还是专题进入的训练,1为正常，2为专题进入
				classroom_id:0,//专题id
			}
		},
		computed:{
			percentage: function(){
				if(this.totalExercise){
					return Math.round((this.currentExercise+1)/this.totalExercise*100)
				}
			},
		},
		methods:{
			//初始化数据
			initData: function(){
				let params = {
					competition_id:this.competitionId,
					paper_id:this.paperId,
					replay_type:this.replay_type,
					classroom_id:this.classroom_id,
				}
				userOpenTrainAnswerData(params).then(response=>{
					this.questionList = response.data.info
					this.totalExercise = response.data.count
					this.currentList = this.questionList[0].paper_info
					this.singleScore = this.currentList[0].score
					this.questionType = this.currentList[0].paper_type
					this.paperTitle = response.paperinfo.paper_title
					this.difficulty = response.paperinfo.difficulty
					this.icon = response.paperinfo.icon
					this.test_introduce = response.paperinfo.paper_introduce
					this.recordId = response.record
					this.paper_status = response.data.is_post
					this.setTestType(this.questionList)
					this.setAnswerBtn(response.data.info,response.data.answer_info)	
					this.changeAnswer()
				})
			},
			setTestType:function(data){
				data.forEach(element => {
					this.testTypes.push({
						name:returnQuestionType(element.paper_type),
						count:element.count_type
					})
				});
			},
			//选择题目，id为题目id，type为题目类型,index为该题下标
			checkQuestion: function(ind,type,index){
				this.currentExercise = index
				this.currentIndex = ind
				this.questionType = type
				this.singleScore = this.answerBtn[index].score
			},
			//@TODO 判断该学生在这场考试的状态，如果已经提交过了就不能再进行修改提交
			postPaper: function(){
				if(this.paper_status){
					return
				}
				if(this.$refs.mychild){
					this.$refs.mychild[0].answerPost()
				}
				setTimeout(()=>{
					let flag = true
					for(let i=0;i<this.answerBtn.length;i++){
						if(!this.answerBtn[i].status){
							flag = false
						}
					}
					let tips = ''
					if(flag){
						tips = '确定提交？'
					}else{
						tips = '还有未完成的题目，确定提交？'
					}
					this.$confirm(tips,'提交活动',{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						showClose:false,
						type: 'warning'
					}).then(()=>{
						let params = {
							competition_id:this.competitionId,
							paper_id:this.paperId,
							record_id:this.recordId,
							replay_type:this.replay_type,
							classroom_id:this.classroom_id,
						}
						userSubmitPaperData(params).then(response=>{
							this.paper_status = 1;
							this.$message.success('提交成功')
							this.$router.go(-1)
						})
					}).catch(()=>{})
				},500)
			},
			//@TODO 关闭考卷离开页面，关闭窗口标签方法不知道什么时候下会失效
			closePaper: function(){
				this.endTestVisible = false
				this.back()
			},
			//判断该题的状态,index为该题下标,status为该题状态
			jugeStatus: function(index,status){
				let cls = ''
				if(this.currentExercise===index){
					cls += ' current-title'
				}
				if(status===1){
					cls += ' completed'
				}else if(status===2){
					cls += ' mistake'
				}
				return cls
			},
			//将所有题目提取出来组成答题卡
			setAnswerBtn: function(data,answer){
				for(let i=0;i<data.length;i++){
					if(data[i].paper_info.length){
						for(let j=0;j<data[i].paper_info.length;j++){
							let paper_type = data[i].paper_info[j].paper_type
							let status = data[i].paper_info[j].status
							const type = returnType(paper_type)
							if(status==1){
								if(!this.answerList[type]){
									this.answerList[type] = []
								}
								let id = data[i].paper_info[j].id
								let ind = answer[type].findIndex(val=>{
									return val.title_id === id
								})
								if(answeIfNull(answer[type][ind].answer,paper_type)){
									this.answerList[type][j] = answer[type][ind].answer
								}else{
									this.answerList[type][j] = ''
									status = 0
								}
							}
							let obj = {
								index:j,
								type:paper_type,
								score:data[i].paper_info[j].score,
								status:status,
							}
							this.answerBtn.push(obj)
						}
					}
				}
			},
			//下一题
			nextQuestion: function(){
				if(this.currentExercise < this.totalExercise){
					this.currentExercise += 1
					this.questionType = this.answerBtn[this.currentExercise].type
					this.currentIndex = this.answerBtn[this.currentExercise].index
					this.changeAnswer()
				}
			},
			//返回
			back(){
				//this.$emit('close')
				if (window.history.length <= 1) {
					this.$router.push({name:'/'})
					return false
				} else {
					this.$router.go(-1)
				}
	        },
			//切换题目，改变当前答案
			changeAnswer: function(){
				let type = returnType(this.questionType)
				this.currentAnswer = ''
				sessionStorage.setItem('answer','')
				if(this.answerList[type]){
					if(this.currentIndex<this.answerList[type].length){
						if(this.answerList[type][this.currentIndex]!==''){
							this.currentAnswer = this.answerList[type][this.currentIndex]
							sessionStorage.setItem('answer',JSON.stringify(this.currentAnswer))
						}
					}
				}
			},
			//判断题目是否已做,type为题目类型,index为题目下标
			jugeItemStatus: function(type,index,currentIndex){
				let answer = this.answerList[type][index]
				if(type==='singleChoice'){
					if(answer!==''){
						this.answerBtn[currentIndex].status=1
					}else{
						this.answerBtn[currentIndex].status=0
					}	
				}else if(type==='multipleChoice'){
					if(answer.length>0){
						this.answerBtn[currentIndex].status=1
					}else{
						this.answerBtn[currentIndex].status=0
					}
				}else if(type==='jugeMent'){
					if(answer!==''){
						this.answerBtn[currentIndex].status=1
					}else{
						this.answerBtn[currentIndex].status=0
					}
				}else if(type==='fill'){
					if(answer.length>0){
						let num = 0
						for(let i=0;i<answer.length;i++){
							if(answer[i]){
								this.answerBtn[currentIndex].status=1
							}else{
								num++
							}
						}
						if(num==answer.length){
							this.answerBtn[currentIndex].status=0
						}
					}
				}else if(type==='gapFill'){
				}else if(type==='line'){
				}else if(type==='short'){
					if(answer!==''){
						this.answerBtn[currentIndex].status=1
					}else{
						this.answerBtn[currentIndex].status=0
					}
				}else if(type==='explain'){
					if(answer!==''){
						this.answerBtn[currentIndex].status=1
					}else{
						this.answerBtn[currentIndex].status=0
					}
				}else if(type==='train'){
					if(answer.content||answer.file.length>0){
						this.answerBtn[currentIndex].status=1
					}else{
						this.answerBtn[currentIndex].status=0
					}
				}else if(type==='multipleSort'){
					let num = 0
					if(answer.length>0){
						for(let i=0;i<answer.length;i++){
							if(answer[i]){
								this.answerBtn[currentIndex].status=1
							}else{
								num++
							}
						}
						if(num==answer.length){
							this.answerBtn[currentIndex].status=0
						}
					}
				}
			}
		},
		filters:{
			returnType:function(val){
				return returnQuestionType(val)
			},
			retrunDifficulty:function(val){
				return retrunDifficulty(val)
			},
		}
	}
</script>

<style scoped="">
	@import url("../../assets/css/preview.css");
</style>